/**
 * Hides MUI Tabs scroller scrollbar and arrow buttons while keeping horizontal scroll
 * (touch, trackpad, shift+wheel). Use with variant="scrollable" tab strips.
 * Spread into `sx` alongside other tab styles.
 */
export const SEVV_TABS_OVERFLOW_SX = {
  '& .MuiTabs-scroller': {
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  '& .MuiTabs-scrollButtons': {
    display: 'none',
  },
} as const
